import { useNavigate } from '@tanstack/react-location';
import { useEffect } from 'react';
import { usePropertyId } from '../../core/hooks/usePropertyId';

const TouristTaxRedirect = () => {
    const propertyId = usePropertyId();
    const navigate = useNavigate();

    useEffect(() => {
        const target = propertyId
            ? `/${propertyId}/financial/tax-payments`
            : '/financial/tax-payments';
        navigate({ to: target, replace: true });
    }, [propertyId, navigate]);

    return null;
};

export default TouristTaxRedirect;
